import Vue from 'vue';
import Slick from 'vue-slick';
import AnimatedComponent from '../../components/Animated';

let els;

if ((els = document.querySelectorAll('.vue-carousel')).length > 0) {
	for (let i = 0; i < els.length; i++) {
		const el = els[i];

		new Vue({
			el: el,
			name: 'VueCarousel',
			components: { Slick, AnimatedComponent },
			data() {
				return {
					cities: [],
					opened: false,
				};
			},
			methods: {
				next() {
					this.$refs.slick.next();
				},
				prev() {
					this.$refs.slick.prev();
				},
				toIndex(index) {
					this.$refs.slick.goTo(index);
				}
			},
			beforeMount() {

			}
		});
	}
}
